export type AiPriseSessionEvent = CustomEvent<{ verification_session_id: string }>;
export type AiPriseBusinessProfileEvent = CustomEvent<{ business_profile_id: string }>;
export type AiPriseDataSavedEvent = CustomEvent<{ email_address: string }>;
export type AiPriseErrorEvent = CustomEvent<{ error_code: string }>;
